module.exports = __webpack_public_path__ + "static/media/hoopaloop-logo.b0b8b6d5.png";